export default __webpack_public_path__ + "static/media/Corpus Ailette.79582c7a.jpg";